import React from "react";
import { userCurrentRole } from "../../../utils/common-functions";
import { FaBriefcaseMedical, FaMapMarkedAlt, FaMapSigns } from "react-icons/fa";
import {
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Box,
  Text,
  Heading,
  Spacer,
  Button
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useGetLowStockQuery } from "../../../api";
import { Flex } from "@chakra-ui/layout";
import { IoMdArrowRoundBack } from "react-icons/io";
import { LowStockAmountPrintPage } from "../../print/components/low-stock-amount-print.page";
interface LowStockComponentProps {}

export const LowStockComponent: React.FC<LowStockComponentProps> = (
  props: LowStockComponentProps
) => {
  let locationId = localStorage.getItem("location");

  const navigate = useNavigate();
  const role = userCurrentRole();
  const goBack = () => {
    navigate(-1);
  };

  const lowStockItems = useGetLowStockQuery({
    query: {
      locationId: Number(locationId),
      role: role
    }
  });

  const PageCardComponent = (props: {
    locationName: string;
    title: string;
    count: number;
    icon: any;
  }) => {
    return (
      <Stack p="5" bg="white" borderRadius="lg" boxShadow="sm" width="100%">
        <Flex alignItems="center">
          <Box>
            <Text fontSize="md" fontWeight="medium">
              {props.locationName}
            </Text>
            <Text fontSize="sm" fontWeight="medium" color="red">
              {props.title}
            </Text>
            <Heading size="md">{props.count}</Heading>{" "}
          </Box>
          <Spacer />
          <Box
            bgColor="#2B6CB0"
            p={3}
            borderRadius="full"
            color="white"
            fontSize="xl"
          >
            {props.icon}
          </Box>
        </Flex>
      </Stack>
    );
  };

  return (
    <Stack>
      <Flex justifyContent="end">
        <Button
          colorScheme="blue"
          leftIcon={<IoMdArrowRoundBack />}
          onClick={() => goBack()}
        >
          Back
        </Button>
      </Flex>
      {lowStockItems.isSuccess && (
        <Stack
          direction={{ base: "column", xl: "row" }}
          onClick={() => goBack()}
        >
          <PageCardComponent
            locationName={lowStockItems.data.location.name}
            title="Low Stock Product"
            count={lowStockItems.data.lowStockCount}
            icon={<FaBriefcaseMedical />}
          />
        </Stack>
      )}
      {lowStockItems.data && (
        <LowStockAmountPrintPage lowstockitem={lowStockItems.data} />
      )}
      <Stack width="100%" overflowX="auto">
        <TableContainer width="100%">
          <Table variant="striped">
            <Thead>
              <Tr>
                <Th>SL</Th>
                <Th>Product Name</Th>
                <Th isNumeric>Quantity</Th>
                <Th>Unit</Th>
              </Tr>
            </Thead>
            {lowStockItems.isSuccess && (
              <Tbody>
                {lowStockItems.data?.lowStock.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td>{index + 1}</Td>
                      <Td
                        style={{
                          whiteSpace: "normal",
                          wordWrap: "break-word"
                        }}
                      >
                        {item.productName}
                      </Td>
                      <Td isNumeric>{item.quantity}</Td>
                      <Td>{item.unit}</Td>
                    </Tr>
                  );
                })}
              </Tbody>
            )}
          </Table>
        </TableContainer>
      </Stack>
    </Stack>
  );
};
